import React, { Component } from 'react'

// Components
import AltButton from './AltButton'
import LinkButton from './LinkButton'

class ImageToolbar extends Component {
    render() {
        const { toolbarTypes, index, assetIndex, file } = this.props

        // console.log(index, file)
        // console.log(toolbarTypes)

        return (
            <div className="drop-toolbar">
                {toolbarTypes.alt &&
                    <AltButton alt={file.alt} index={index} assetIndex={assetIndex} closeAction={(alt, index) => toolbarTypes.alt.updateAlt(alt, index, !!file.id, assetIndex)} />
                }
                {toolbarTypes.link &&
                    <LinkButton href={file.link} index={index} assetIndex={assetIndex} closeAction={(href, index) => toolbarTypes.link.updateLink(href, index, !!file.id, assetIndex)} />
                }
            </div>
        )
    }
}

export default ImageToolbar



// WEBPACK FOOTER //
// ./src/components/utils/image-toolbar/ImageToolbar.js